import { gql } from '@apollo/client';

export const GET_FCHECK_LAST = gql`
 query getFintelCheckLast($input: FintelCheckSearchInput!) {
    fintelChecksOverview(input: $input) {
      lastCheckDate
    }
  }
`;
